// ePayco checkout v2 [RGM] 2026-09-15 — flujo oficial vigente: el backend crea
// la sesión (login + payment/session/create) y aquí se abre el widget con
// checkout-v2.js. El checkout viejo (checkout.php) devuelve 403.

const URL_SCRIPT = 'https://checkout.epayco.co/checkout-v2.js'
const MENSAJE_ERROR = 'No se pudo cargar el checkout de ePayco.'

/** Opciones del widget checkout-v2 (las únicas que envía SiprinIA). */
interface EpaycoOpciones {
  sessionId: string
  type: 'standard'
  test: boolean
}

/** Instancia del widget: configure(...).open(). */
interface EpaycoWidget {
  open: () => void
}

/** API global que expone checkout-v2.js. */
interface EpaycoCheckout {
  configure: (opciones: EpaycoOpciones) => EpaycoWidget
}

declare global {
  interface Window {
    ePayco?: { checkout: EpaycoCheckout }
  }
}

// Un solo intento de carga por página: la promesa en curso se comparte entre
// llamadas concurrentes y el tag se reutiliza.
let cargaEnCurso: Promise<void> | null = null
let etiqueta: HTMLScriptElement | null = null

/**
 * Carga checkout-v2.js UNA sola vez (comparte la promesa en curso y reutiliza
 * el tag ya cargado). Si la carga falla, el intento se libera: se quita el tag
 * roto (sus eventos load/error ya se dispararon) y se limpia la promesa, de
 * modo que un reintento inyecte un script nuevo y real. Rechaza si el script
 * no puede cargarse.
 */
function cargarCheckout(): Promise<void> {
  if (window.ePayco) return Promise.resolve()
  if (cargaEnCurso) return cargaEnCurso

  cargaEnCurso = new Promise<void>((resolve, reject) => {
    // Tag de un intento anterior fallido: ya no disparará eventos, se retira
    // antes de inyectar el script nuevo.
    if (etiqueta) etiqueta.remove()

    const script = document.createElement('script')
    etiqueta = script
    script.src = URL_SCRIPT
    script.async = true
    script.addEventListener('load', () => resolve(), { once: true })
    script.addEventListener('error', () => {
      // Fallo definitivo: libera el intento para un reintento real.
      cargaEnCurso = null
      etiqueta = null
      script.remove()
      reject(new Error(MENSAJE_ERROR))
    }, { once: true })
    document.head.appendChild(script)
  })
  return cargaEnCurso
}

/**
 * Abre el checkout con el sessionId creado por el backend. Await de la carga
 * (única por página) y verificación de la API global antes de configurar el
 * widget.
 */
export async function abrirCheckoutEpayco(sessionId: string, test: boolean): Promise<void> {
  await cargarCheckout()
  const checkout = window.ePayco?.checkout
  if (!checkout) throw new Error(MENSAJE_ERROR)
  checkout.configure({ sessionId, type: 'standard', test }).open()
}
